export const VIEW_BY = {
  CREDIT_RISK_SCORE: 'CREDIT_RISK_SCORE',
  PERFORMANCE_SCORE: 'PERFORMANCE_SCORE',
}

export const MODEL_ID = {
  CREDIT_RISK: 1,
  PERFORMANCE: 2,
  CORPORATE_RISK: 3,
}

export const PORTFOLIO_DETAIL_PATH = {
  numberCompanies: 'PortfolioInsights/HighestPortFolioByIdDetails',
  highestCompanies: 'PortfolioInsights/HighestPortFolioDetails',
  newHighestCompanies: 'PortfolioInsights/NewHighestPortFolioDetails',
}

export const INDUSTRY_DETAIL_PATH = {
  numberCompanies: 'PortfolioInsights/HighestIndustryByIdDetails',
  highestCompanies: 'PortfolioInsights/HighestIndustryDetails',
  newHighestCompanies: 'PortfolioInsights/NewHighestIndustryDetails',
}
